<template>
    <form @submit.prevent data-vv-scope="consentForm">
        <!-- padl20 -->
        <div class="form-container settings-form pl-10 pr-10">
            <h3 class="small-header pl-0">Consent Content</h3>
            <div class="vx-row">
                <div class="vx-col w-full mb-10 ownership_editor">
                    <div class="form_group">
                        <quillTextEditor  :display="false" :wrapclass="''" :formscope="'consentForm'" v-model="consent"
                        :fieldName="'consent'"  :required="true"  :customValidNotRequire="true"
                         :label="'Consent'" :placeHolder="'Consent'"  :canSpellCheck="true"/>
                    </div>
                </div>
                <div class="vx-col w-full mb-10 ownership_editor">
                    <div class="form_group">
                        <quillTextEditor  :display="false" :wrapclass="''" :formscope="'consentForm'" v-model="termsAndConditions"
                        :fieldName="'termsAndConditions'"  :required="true"  :customValidNotRequire="true"
                         :label="'Terms and Conditions'" :placeHolder="'Terms and Conditions'"  :canSpellCheck="true"/>
                    </div>
                </div>


                <div class="vx-col w-100">
                    <div class="popup-footer form-footer form-footer2 height-auto mb-4">
                        <vs-button color="success" class="save"  @click="updateConsent"
                            type="filled">
                            <template v-if="true">Update</template>
                            <template v-else>Save</template>
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import quillTextEditor from "@/views/forms/fields/quillTextEditor.vue";
export default {
    provide(){
        return {
            parentValidator: this.$validator,
        };
    },
    props:{

    },
    components: {
        quillTextEditor
    },
    data: () => ({
        consent:'',
        termsAndConditions:'',
    }),
    watch:{

    },
    methods:{
        updateConsent(){
            this.$validator.validateAll('consentForm').then((result)=>{
                if(result){
                    let payLoad = {
                        tenantId:this.getTenantId,
                        consent:this.consent,
                        termsAndConditions:this.termsAndConditions
                    };
                    let path = '/global/consent-content';
                    this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
                        this.showToster({ message: res.message, isError: false });
                        this.getConsentDetails();
                    }).catch((err)=>{
                        this.showToster({ message: err, isError: true });
                    })
                }
            })
        },
        getConsentDetails(){
            let path = '/global/get-consent-content';
            let payLoad = {
                tenantId:this.checkProperty( this.getUserData, 'tenantId')
            };
            this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
                if(res){
                    if(res['consent']){
                        this.consent = res['consent'];
                    }
                    if(res['termsAndConditions']){
                        this.termsAndConditions = res['termsAndConditions'];
                    }
                }
                // console.log(JSON.stringify(res))
            }).catch((err)=>{

            })
        },
    },
    mounted(){
        this.getConsentDetails();
    },
    computed:{

    },
}

</script>